import { Controller } from "@hotwired/stimulus"

// The contractors hero's phone (TASK-300; Www::ScanFlow): a timer-driven state
// machine, ported from docs/prototypes/hero-animations-prototype.html. It
// moves ONE phase class on the phone screen —
//
//   www-scan--scan     camera, sweeping scanline, wide reticle
//   www-scan--lock     reticle snaps to the plate, the QTAG chip rises
//   www-scan--form     the inspection sheet slides up; rows tick, photo fills,
//                      submit presses
//   www-scan--success  the tick draws; the register row behind flips
//
// — and every transition lives in www_hero_art.css. No library, nothing
// measured. The markup rests in the synced state (form filled, register
// Compliant); with prefers-reduced-motion it stays there, otherwise the loop
// rewinds to the camera and plays, 13s a cycle.
const PHASES = ["www-scan--scan", "www-scan--lock", "www-scan--form", "www-scan--success"]
const CYCLE = 13000

export default class extends Controller {
  static values = { labels: Object }
  static targets = ["screen", "row", "photo", "submit", "regRow", "regPill", "regWhen"]

  connect() {
    this.timers = []
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return
    this.cycle()
  }

  disconnect() {
    this.clearTimers()
  }

  phase(name) {
    PHASES.forEach((phase) => this.screenTarget.classList.toggle(phase, phase === name))
  }

  at(ms, fn) {
    this.timers.push(setTimeout(fn, ms))
  }

  clearTimers() {
    this.timers.forEach(clearTimeout)
    this.timers = []
  }

  cycle() {
    this.clearTimers()
    this.phase("www-scan--scan")
    this.rowTargets.forEach((row) => row.classList.remove("is-done"))
    this.photoTarget.classList.remove("is-filled")
    this.submitTarget.classList.remove("is-pressed")
    this.registerReset()

    this.at(3200, () => this.phase("www-scan--lock"))
    this.at(4400, () => this.phase("www-scan--form"))
    this.at(5300, () => this.rowTargets[0].classList.add("is-done"))
    this.at(6100, () => this.rowTargets[1].classList.add("is-done"))
    this.at(6900, () => this.rowTargets[2].classList.add("is-done"))
    this.at(7700, () => this.photoTarget.classList.add("is-filled"))
    this.at(8800, () => this.submitTarget.classList.add("is-pressed"))
    this.at(9150, () => this.phase("www-scan--success"))
    this.at(9900, () => this.registerSynced())
    this.at(CYCLE, () => this.cycle())
  }

  // The standalone phone (How it Works, TASK-301.2) has no register behind it.
  get hasRegister() {
    return this.hasRegRowTarget && this.hasRegPillTarget && this.hasRegWhenTarget
  }

  registerReset() {
    if (!this.hasRegister) return
    this.regPillTarget.className = "www-art-pill www-art-pill--due"
    this.regPillTarget.textContent = this.labelsValue.due_soon
    this.regWhenTarget.textContent = this.regWhenTarget.dataset.rested
    this.regRowTarget.classList.remove("is-flash")
  }

  registerSynced() {
    if (!this.hasRegister) return
    this.regPillTarget.className = "www-art-pill www-art-pill--ok"
    this.regPillTarget.textContent = this.labelsValue.compliant
    this.regWhenTarget.textContent = this.labelsValue.just_now
    this.regRowTarget.classList.remove("is-flash")
    void this.regRowTarget.offsetWidth
    this.regRowTarget.classList.add("is-flash")
  }
}
